<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <i class="md-icon fas fa-folder-open"/>
                    </div>
                    <h4 class="title">Liste des documents</h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                    <div class="flex items-center">
                        <md-button class="md-info md-sm md-datatable"
							@click="goToRoute('Add Document')">
                            <md-icon class="material-icons mr-1">add</md-icon>
                            <span>Ajouter un document</span>
                        </md-button>
                    </div>
                </div>
            </div>
        </md-card-header>
        <template v-if="documents.length > 0">
            <md-card-content class="mt-2">
                <md-table
                    :value="queriedData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table"
                >
                    <md-table-toolbar>
                        <md-field>
                            <label for="pages">Éléments à afficher</label>
                            <md-select v-model="pagination.perPage" name="pages">
                                <md-option
                                    v-for="item in pagination.perPageOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>

                        <md-field>
                            <md-input
                                type="search"
                                clearable
                                style="width: 250px"
                                placeholder="Rechercher..."
                                v-model="searchQuery"
                            >
                            </md-input>
                        </md-field>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="#" md-sort-by="id" style="max-width: 50px;">
                            {{ item.id }}
                        </md-table-cell>
                        <md-table-cell md-label="Nom" md-sort-by="name" style="min-width: 420px;">
                            {{ item.name }}
                        </md-table-cell>
                        <md-table-cell md-label="Catégorie" md-sort-by="typeName" style="min-width: 470px;">
                            {{ item.typeName }}
                        </md-table-cell>
                        <md-table-cell md-label="Poids" style="max-width: 30px">
                            <div class="edit-order">
								<md-field class="md-invalid">
									<md-input v-model="item.order" name="order" type="number" @keyup.enter="updateDocumentOrder(item); $event.target.blur()"></md-input>
								</md-field>
							</div>
                        </md-table-cell>
                        <md-table-cell md-label="Fichier">
                            <div style="margin-right: .25rem;">
                                <md-button class="md-icon-button md-raised md-info"
									:href="item.url" target="_blank">
                                    <i class="md-icon fa fa-download"/>
                                </md-button>
                                <md-tooltip md-direction="top">Télécharger</md-tooltip>
                            </div>
                            <div style="margin-right: .25rem;">
                                <md-button class="md-icon-button md-raised md-warning"
									@click="goToRoute('Edit Document', item.id)">
                                    <i class="md-icon fa fa-pen"/>
                                </md-button>
                                <md-tooltip md-direction="top">Modifier</md-tooltip>
                            </div>
                            <div>
                                <md-button class="md-icon-button md-raised md-danger"
									@click="handleDelete(item)">
                                    <i class="md-icon fa fa-trash"/>
                                </md-button>
                                <md-tooltip md-direction="top">Supprimer</md-tooltip>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
                <div class="">
                    <p class="card-category">
                        Affichage de l'élement {{ from + 1 }} à {{ to }} sur {{ total }} éléments
                    </p>
                </div>
                <pagination
                    class="pagination-no-border pagination-info"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                >
                </pagination>
            </md-card-actions>
        </template>
        <md-card-content v-else class="mt-2">
            Aucun documents liés détectés.
        </md-card-content>
    </md-card>
</template>

<script>
import Fuse from "fuse.js";
import { Pagination } from "@/components";

export default {
    name: "DocumentsTable",
    components: {
        Pagination
    },
    data() {
        return {
            documents: [],
            documentTypes: [],
            currentSort: "id",
            currentSortOrder: "desc",
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            searchedData: [],
        }
    },
    props: {
        documentsData: Array
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.documents;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.documents.length;
        }
    },
    mounted() {
        this.formatData()
    },
    methods: {
        formatData() {
            // Formatage de la liste des documents
            this.documentsData.map(doc => {
                doc.typeName = doc.type.parent ? doc.type.parent.name + ' / ' + doc.type.name : doc.type.name
            })
            this.documents = this.documentsData
        },
        customSort(value) {
            const sortBy = this.currentSort;
            return value.sort((a, b) => {
                if (this.currentSortOrder === "desc") {
                    if (sortBy === 'id') {
                        if (a.id > b.id) {
                            return 1;
                        } else if (b.id > a.id) {
                            return -1;
                        }
                        return 0;
                    }
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                if (sortBy === 'id') {
                    if (a.id > b.id) {
                        return -1;
                    } else if (b.id > a.id) {
                        return 1;
                    }
                    return 0;
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
		handleDelete(item) {
			this.$swal.fire({
				title: "Êtes-vous sûr ?",
				text: `Voulez-vous vraiment supprimer ce document ?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonClass: "md-button md-success",
				cancelButtonClass: "md-button md-warning",
				confirmButtonText: "Supprimer",
				cancelButtonText: "Annuler",
				buttonsStyling: false
			}).then(async result => {
				if(result.value) {
					try {
						await this.$store.dispatch('documents/deleteDocument', item.id)
						await this.$store.dispatch("alerts/success", "Document supprimé")
						this.$emit('deleted')
					}
					catch(e) {
						await this.$store.dispatch("alerts/error", "Suppression impossible")
					}
				}
			});
		},
        async updateDocumentOrder(doc) {
            let document = {
                ...doc,
                order: parseInt(doc.order)
            }
            try {
				const { data } = await this.$store.dispatch('documents/updateDocumentOrder', document)
				if(data === 'same order') {
					await this.$store.dispatch('alerts/warning', 'Poids identique')
				} else {
					await this.$store.dispatch('alerts/success', 'Poids modifié')
					this.$emit('updated')
				}
            } catch (e) {
				await this.$store.dispatch('alerts/error', e.response.data.errors[0].detail)
            }
        },
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id }})
		}
    },
    watch: {
        searchQuery(value) {
            let result = this.documents;
            if (value !== "") {
                let fuse = new Fuse(this.documents, {
                    keys: ["name", "typeName"],
                    threshold: 0.3
                });
                result = fuse.search(this.searchQuery);
            }
            this.searchedData = result;
        },
        documentsData: function(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.formatData()
            }
        }
    }
}
</script>

<style scoped>

</style>
